import { useMemo, useCallback } from 'react';
import { MapMarker } from '../components/map/GenericMap';

export interface PriceLocation {
  id: string;
  productName?: string;
  price?: number;
  coordinates: {
    lat: number;
    long: number;
  };
  establishmentName?: string;
  reportedTime?: number;
  priceCount?: number;
  latestPrices?: PriceLocation[];
  latestReportedTime?: number;
  allPrices?: PriceLocation[];
}

export interface UsePriceMapDataProps {
  priceLocations: PriceLocation[];
  formatPrice?: (price: number | undefined) => string;
  formatDate?: (timestamp: number) => string;
  t?: (key: string) => string;
}

export const usePriceMapData = ({
  priceLocations,
  formatPrice = (price: number | undefined) => {
    if (price === undefined || price === null) {
      return 'L. 0.00';
    }
    return `L. ${price.toFixed(2)}`;
  },
  formatDate = (timestamp: number) => {
    if (!timestamp || isNaN(timestamp)) {
      return 'Invalid Date';
    }
    try {
      return new Date(timestamp).toLocaleDateString();
    } catch (error) {
      console.error('Error formatting date:', error, 'timestamp:', timestamp);
      return 'Invalid Date';
    }
  },
  t = (key: string) => key,
}: UsePriceMapDataProps) => {
  const markers: MapMarker[] = useMemo(() => {
    return priceLocations.map((location) => ({
      id: location.id,
      coordinates: location.coordinates,
      data: location,
      iconUrl: 'https://cdn-icons-png.flaticon.com/512/684/684908.png',
      iconSize: location.priceCount && location.priceCount > 1 ? [30, 30] : [25, 25],
      iconAnchor: location.priceCount && location.priceCount > 1 ? [15, 15] : [12, 12],
      popupAnchor: location.priceCount && location.priceCount > 1 ? [0, -15] : [0, -12],
    }));
  }, [priceLocations]);

  const renderPopup = useCallback(
    (marker: MapMarker) => {
      const location = marker?.data as PriceLocation;

      // if (location.latestPrices && location.latestPrices.length > 1) {
      return (
        <div className="max-w-xs p-2">
          <h3 className="text-lg font-semibold">
            {location?.latestPrices?.length} {t('products')}
          </h3>
          <div className="mt-2 max-h-[150px] space-y-2 overflow-auto">
            {location?.latestPrices?.map((price, index) => (
              <div
                key={index}
                className="flex flex-col justify-between border-b border-gray-100 pb-1"
              >
                <p className="text-sm font-medium">{price?.productName} </p>
                <span className="text-sm font-bold text-green-600">
                  {formatPrice(price?.price)}
                </span>
              </div>
            ))}
            {/* <p className="pt-1 text-xs text-gray-500">
                {t('lastUpdated')}: {formatDate(location.latestReportedTime!)}
              </p> */}
          </div>
          <p className="pt-1 text-xs text-gray-500">
            {t('lastUpdated')}: {formatDate(location?.latestReportedTime!)}
          </p>
        </div>
      );
      // } else {
      //   return (
      //     <div>
      //       <h3 className="font-semibold">{location.latestPrices?.[0]?.productName}</h3>
      //       <p className="text-lg font-bold text-green-600">
      //         {formatPrice(location.latestPrices?.[0]?.price)}
      //       </p>
      //       {location.latestPrices?.[0]?.establishmentName && (
      //         <p className="text-sm text-gray-600">
      //           {t('establishmentaaa')}: {location.latestPrices[0].establishmentName}
      //         </p>
      //       )}
      //       <p className="text-xs text-gray-500">
      //         {t('reportedOn')}: {formatDate(location.latestReportedTime!)}
      //       </p>
      //     </div>
      //   );
      // }
    },
    [formatPrice, formatDate, t]
  );

  return {
    markers,
    renderPopup,
  };
};
